import { useUser } from 'modules/user/userSelector';
import { User } from 'types/User';

/**
 * Whether the current account is in the Media Library rollout.
 *
 * The only source is the api's `features_toggle.media_library` from `/me/data`
 * (allowlist `MEDIA_LIBRARY_ROLLOUT_ACCOUNT_IDS`). An api that predates the
 * toggle omits the key, and the reducer's default is replaced wholesale by the
 * payload, so anything but an explicit `true` means off.
 */
export function isMediaLibraryEnabled(user: Pick<User, 'features_toggle'>) {
  return user.features_toggle?.media_library === true;
}

export function useIsMediaLibraryEnabled(): boolean {
  return isMediaLibraryEnabled(useUser());
}
